<ng-container *transloco="let t" class="container">
  <form [formGroup]="inputForm">
    <app-admin-modal-layout [title]="title ?? ''"
            [saveLabel]="confirmButtonTitle ?? t('app.common.confirm')" (onSave)="onConfirmClick()"
            (onClose)="onDismissClick()" [saveDisabled]="!saveEnabled">
      <div class="border-shadow p-3">
        <app-competitor-info [isTeam]="forTeamMembers" [competitor]="competitor"/>
      </div>

      <div class="border-shadow mt-3">
        <table class="table w-100">
          <thead>
          <tr>
            <th>{{ t('organiser.event.details.control.point.type') }}</th>
            <th>{{ t('measurements.time') }}</th>
            <th>{{ t('measurements.chipTime') }}</th>
            @if (raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED) {
            <th>{{ t('competitor.table.distance')}}</th>
            }
            <th scope="col" class="more-column-width"></th>
          </tr>
          </thead>
          <tbody>
          @for (section of sections; track section.member?.id ?? 'solo') {
          @if (forTeamMembers) {
          <tr class="member-row" (click)="toggleSection(section)">
            <td [attr.colspan]="raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED ? 4 : 3">
              <div>
                <div class="detail-col-title mb-0">
                  {{ ((section.member?.firstName ?? '' ) | uppercase) + " " + ((section.member?.lastName ?? '' ) | uppercase) }}
                </div>
                <div class="d-flex gap-2 justify-content-start">
                  <div>{{t('app.common.chipNumber')}}: {{ section.member?.chipNumber ?? '-' }}</div>
                  <div>|</div>
                  <div>{{t('competitor.table.startNumberExtension')}}: {{ section.member?.startNumberExtension ?? '-' }}</div>
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex w-100 justify-content-center align-items-center">
                <i class="bi color-grey-neutral-400" [ngClass]="section.expanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </div>
            </td>
          </tr>
          }

          @if (section.expanded) {
          @for (controlTime of section.controlTimes; track controlTime; let idx = $index) {
          <tr [class.deciding-row]="decidingRowsByWaypointId.get(controlTime.controlWaypoint?.id!) === controlTime"
              [class.error]="(controlTime.id !== -1) && saveResult.get(controlTime.id!) && saveResult.get(controlTime.id!) !== CompetitorSaveControlPointResultStatus.OK"
              [class.disabled]="controlTime.id === -1"
              [class.active]="selectedControlTime === controlTime"
              (click)="onControlTimeRowSelect(section, controlTime)">
            <td class="center-align">
              @if (controlTime.controlWaypoint?.waypointTypeId === WaypointType.CONTROL_WAYPOINT) {
                <app-language-output [hrLabel]="controlTime.controlWaypoint?.pointNameHr"
                                     [enLabel]="controlTime.controlWaypoint?.pointNameEn"
                                     [srLabel]="controlTime.controlWaypoint?.pointNameSr"
                                     [itLabel]="controlTime.controlWaypoint?.pointNameIt"
                                     [siLabel]="controlTime.controlWaypoint?.pointNameSlo"
                                     [bsLabel]="controlTime.controlWaypoint?.pointNameBs"
                                     [languages]="languages"/>
                } @else if (!controlTime.controlWaypoint && (controlTime?.lap ?? 0) > 0) {
                {{ t('measurements.lap.label', {lap: controlTime.lap}) }}
                } @else {
                {{ t("organiser.event.details.control.point.waypointType." + controlTime.controlWaypoint?.waypointTypeId) }}
            }
            </td>
            <td class="center-align">
              {{ (controlTime?.time) ? (controlTime?.time | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-' }}
              @if ((controlTime.id !== -1) && saveResult.get(controlTime.id!) && saveResult.get(controlTime.id!) !== CompetitorSaveControlPointResultStatus.OK) {
                <i class="ps-2 bi bi-info-circle info-icon p" style="font-size: 14px;"
                    ngbTooltip="{{ t('measurements.competitor.control.point.save.error.' + saveResult.get(controlTime.id!)) }}"
                    placement="left">
                </i>
              }
            </td>
          <td class="center-align">
            {{ (controlTime?.chipTime) ? (controlTime?.chipTime | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-'}}
          </td>
          @if (raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED) {
            <td class="center-align"> {{controlTime?.lapDistancePassed}} </td>
          }

          <td class="center-align">
            <div class="d-flex justify-content-center align-items-center">
              <input type="radio" class="form-check-input" name="selected"
                     [checked]="selectedControlTime === controlTime"
                     (change)="onControlTimeRowSelect(section, controlTime)"
                     [disabled]="controlTime.id === -1">
            </div>
          </td>
        </tr>
          }
          }
          }
          </tbody>
        </table>
      </div>

      @if (selectedControlTime) {
      <div class="border-shadow mt-3 p-16">
        <div class="d-flex justify-content-between align-items-start pb-1">
  <div>
    <div class="detail-col-title">{{ t('measurements.edit.checkpoint.title') }}</div>
    <div class="detail-col-desc">
      {{ t('measurements.edit.checkpoint.desc') }}
      @if (forTeamMembers) {
      <strong>
        {{ ((selectedSection?.member?.firstName ?? '' ) | uppercase) + " " + ((selectedSection?.member?.lastName ?? '' ) | uppercase) }}
      </strong>;
      }
      <strong>
        @if (selectedControlTime?.controlWaypoint?.waypointTypeId === WaypointType.CONTROL_WAYPOINT) {
      <app-language-output [hrLabel]="selectedControlTime?.controlWaypoint?.pointNameHr"
                           [enLabel]="selectedControlTime?.controlWaypoint?.pointNameEn"
                           [srLabel]="selectedControlTime?.controlWaypoint?.pointNameSr"
                           [itLabel]="selectedControlTime?.controlWaypoint?.pointNameIt"
                           [siLabel]="selectedControlTime?.controlWaypoint?.pointNameSlo"
                           [bsLabel]="selectedControlTime?.controlWaypoint?.pointNameBs"
                           [languages]="languages"/>
      } @else if (!selectedControlTime?.controlWaypoint && (selectedControlTime?.lap ?? 0) > 0) {
      {{ t('measurements.lap.label', {lap: selectedControlTime?.lap}) }}
      } @else {
      {{ t("organiser.event.details.control.point.waypointType." + selectedControlTime?.controlWaypoint?.waypointTypeId) }}
      }
      </strong>
    </div>
  </div>
</div>

        <div class="d-flex gap-3 align-items-start flex-column flex-lg-row justify-content-stretch">
          <div class="flex-grow-1 w-100-smaller-than-lg">
            <app-date-time-input formControlName="time"
                                 [displayTime]="true"
                                 [displaySeconds]="true" [minDate]="startDate" [maxDate]="finishDate"
                                 [displayMilliseconds]="true" [label]="t('measurements.time')"/>
          </div>
          <div class="flex-grow-1 w-100-smaller-than-lg">
            <app-date-time-input formControlName="chipTime" [displayTime]="true" [displaySeconds]="true"
                                 [displayMilliseconds]="true" [label]="t('measurements.chipTime')"/>
          </div>
          @if (isFinishWaypoint) {
          <div class="flex-grow-1 w-100-smaller-than-lg">
            <app-input type="number" formControlName="penaltyMinutes"
                   [label]="t('measurements.controlpoints.penalty.minutes')"/>
          </div>
      }
      @if (displayDistanceInput) {
      <div class="flex-grow-1 w-100-smaller-than-lg">
        <app-input type="number" formControlName="lapDistancePassed" [label]="t('measurements.lap.passed.distance')"/>
      </div>
      }
    </div>


      </div>
    }

    </app-admin-modal-layout>
  </form>
</ng-container>